import { render, staticRenderFns } from "./productAdvantage.vue?vue&type=template&id=21464a96&scoped=true"
import script from "./productAdvantage.vue?vue&type=script&lang=js"
export * from "./productAdvantage.vue?vue&type=script&lang=js"
import style0 from "./productAdvantage.vue?vue&type=style&index=0&id=21464a96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21464a96",
  null
  
)

export default component.exports